import { gql } from '@apollo/client';
import { Date } from 'graphql/main/mutations';
import {
  DEMAND,
  POST_MODE,
  PROJECT_TYPE,
  Post,
  REAL_ESTATE_TYPE,
  TYPE,
  fromTo,
} from 'graphql/main/mutations/temp/create-post';
import { Boolean, ID, Int, String } from '../get-real-estates';
import { PaginationOf } from '../get-user-saved-real-estate';

export interface RangeDate {
  from?: Date;
  to?: Date;
}
export interface PostFilters {
  type?: TYPE;
  demand?: DEMAND;
  realEstateType?: REAL_ESTATE_TYPE;
  province?: String;
  district?: String;
  ward?: String;
  street?: String;
  houseNumber?: String;
  price?: fromTo;
  contactPhone?: String;
  hasAlley?: Boolean;
  floorCount?: fromTo;
  width?: fromTo;
  length?: fromTo;
  area?: fromTo;
  projectName?: String;
  userId?: ID;
  mode?: POST_MODE;
  createdAt?: RangeDate;
  projectType?: PROJECT_TYPE;
}
export enum POST_TYPE {
  home = 'home',
  user = 'user',
  favorite = 'favorite',
}
export interface PostPagination extends PaginationOf {
  data?: Post[];
}

export interface PostsData {
  posts?: PostPagination;
}
export interface PostsVariables {
  page?: Int;
  limit?: Int;
  sort?: String;
  postType?: POST_TYPE;
  filters?: PostFilters;
  exceptId?: ID;
}

export const POSTS = gql`
  query posts(
    $page: Int
    $limit: Int
    $sort: String
    $postType: POST_TYPE
    $filters: PostFilters
    $exceptId: ID
  ) @api(name: social) {
    posts(
      page: $page
      limit: $limit
      sort: $sort
      postType: $postType
      filters: $filters
      exceptId: $exceptId
    ) {
      data {
        alleyWidth
        area {
          from
          to
        }
        bedroomCount {
          from
          to
        }
        blockCode
        body
        commentCount
        commission
        contactPhone
        createdAt
        demand
        hidden
        district {
          id
          name
        }
        floorCount {
          from
          to
        }
        hasAlley
        houseNumber
        id
        images {
          fileId
          type
          originalUrl
        }
        interiorStatus
        isLiked
        legals
        length {
          from
          to
        }
        likeCount
        mode
        ownerName
        price {
          from
          to
        }
        priceDetail {
          area {
            from
            to
          }
          name
          price {
            from
            to
          }
        }
        projectName
        projectType
        province {
          id
          name
        }
        realEstateType
        slug
        street {
          id
          name
        }
        title
        toiletCount {
          from
          to
        }
        turnCount
        type
        user {
          avatar {
            fileId
            originalKey
            originalUrl
            type
          }
          fullName
          id
          phone
        }
        ward {
          id
          name
        }
        width {
          from
          to
        }
      }
      hasNextPage
      hasPrevPage
      limit
      nextPage
      page
      pagingCounter
      prevPage
      total
      totalPages
    }
  }
`;
